export const BLACK = '#000';
export const DARK_BLACK = '#121212';
export const LIGHT_BLACK = '#1E1E1E';
export const ORANGE = '#E98300';

export const LIGHT_GRAY = '#F8F8F8';
export const GRAY = '#696969';
export const WHITE = '#fff';
export const GREEN = '#0ae600';
export const BLUE = '#0288d1';
export const RED = '#ff0000';
